import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { Toast } from './components/Widgets.tsx';
import { onAppUrlOpen } from './lib/native.ts';
import { startSession } from './lib/session.ts';
import { Home } from './pages/Home.tsx';
import { Privacy, Terms } from './pages/Legal.tsx';
import { MapPage } from './pages/MapPage.tsx';
import { Notifications } from './pages/Notifications.tsx';
import { Profile } from './pages/Profile.tsx';
import { Settings } from './pages/Settings.tsx';
import { SignIn } from './pages/SignIn.tsx';

function DeepLinks() {
  const navigate = useNavigate();
  useEffect(() => {
    void onAppUrlOpen((url) => {
      try {
        const u = new URL(url);
        navigate(u.pathname + u.search);
      } catch {
        // ignore
      }
    });
  }, [navigate]);
  return null;
}

export function App() {
  useEffect(() => {
    void startSession();
  }, []);
  return (
    <BrowserRouter>
      <DeepLinks />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/t/:tileId" element={<MapPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toast />
    </BrowserRouter>
  );
}
